import { manufacturersCapacityParcel } from '~/parcels/index.js';
import { LitEntity, html } from '../js/utility/lit-entity';
import './parcel-loader';
import { buttonStyles } from '../js/styles/button-styles';

class ManufacturersCapacityDialog extends LitEntity {
  static get properties() {
    return {
      show: { type: Boolean },
    };
  }

  static get styles() {
    return buttonStyles;
  }

  render() {
    const passThroughProperties = {
      href: this.href,
      capacity: this.entity && this.entity.properties.listedCapacity,
      show: this.show,
      handleClose: async () => {
        this.show = false;
      },
    };

    return html`
      <div>
        <button class="button button--plain" @click="${() => this.show = true}">
          <span>edit</span>
        </button>
        <div id="manufacturer-capacity-parcel"></div>
        <parcel-loader
          .parcel=${manufacturersCapacityParcel}
          .passThroughProperties=${passThroughProperties}
          parcel-is-dialog
        ></parcel-loader>
      </div>
    `;
  }
}

window.customElements.define('manufacturers-capacity-dialog', ManufacturersCapacityDialog);
